import gsap from 'gsap';
import { Draggable, InertiaPlugin } from 'gsap/all';
gsap.registerPlugin(Draggable, InertiaPlugin);

const selectors = {
  el: '.js-draggable:not(.is-initialized)',
  item: '.js-draggable-item',
};

const randomPositions = [
  { x: '45vw', xPercent: -100, y: '40vh', yPercent: -100, rotate: -10 },
  { x: '50vw', xPercent: -100, y: '63vh', yPercent: -100, rotate: 4 },
  { x: '95vw', xPercent: -100, y: '55vh', yPercent: -100, rotate: -8 },
  { x: '70vw', xPercent: -100, y: '75vh', yPercent: -100, rotate: -10 },
]

const init = () => {
  const els = document.querySelectorAll(selectors.el);
  const draggables = [];

  els.forEach(el => {
    el.classList.add('is-initialized');
    const mq = el.dataset.draggableMq ? window.matchMedia(el.dataset.draggableMq) : window.matchMedia('(min-width: 768px)');
    const items = el.querySelectorAll(selectors.item);
    items.forEach((item, i) => {
      Draggable.create(item, {
        inertia: true,
        dragResistance: 0.1,
        bounds: el,
      });

      if (item.matches('[data-random-position]') && randomPositions[i] && mq.matches) {
        gsap.set(item, randomPositions[i]);
      } else if (item.matches('[data-random-position]') && mq.matches) {
        const containerBounds = el.getBoundingClientRect();
        gsap.set(item, {
          x: Math.floor(Math.random() * (containerBounds.width - el.offsetWidth)),
          y: Math.floor(Math.random() * (containerBounds.height - el.offsetHeight)),
          rotate: Math.floor(Math.random() * 30 - 15),
        });
      }
      draggables.push(Draggable.get(item));
    });
  
    if (!mq.matches) {
      draggables.forEach(draggable => {
        draggable.disable();
      });
    }
  
    mq.addEventListener('change', () => {
      if (mq.matches) {
        draggables.forEach(draggable => {
          draggable.enable();
        });
      } else {
        draggables.forEach(draggable => {
          draggable.disable();
        });
      }
    });
  });
  
};

const module = () => {
  init();
  document.addEventListener('domUpdated', init);
};

export default module;
